const ReplyMixin = {
  methods: {
    getReplyMessage() {
      switch (this.form.message_type) {
        case 'text': return { text: this.form.message }
        case 'buttons': return {
          attachment: {
            type: 'template',
            payload: {
              template_type: 'button',
              text: this.form.message,
              buttons: this.form.buttons,
            },
          },
        }
        case 'generic': return {
          attachment: {
            type: 'template',
            payload: {
              template_type: 'generic',
              image_aspect_ratio: 'horizontal',
              elements: this.form.cards,
            },
          },
        }
        case 'image': return {
          attachment: {
            type: 'image',
            payload: {
              is_reusable: true,
              url: this.form.image,
            },
          },
        }
        default: return false
      }
    },
    setMessage(reply, type, storeLabel = 'reply/') {
      // eslint-disable-next-line default-case
      let typeIndex = 0
      const formLabel = `${storeLabel}SET_FORM`
      switch (type) {
        case 'buttons': {
          this.$store.commit(formLabel, {
            message: reply?.attachment?.payload?.text ?? '',
            buttons: reply?.attachment?.payload?.buttons ?? [],
          })
          typeIndex = 1
          break
        }
        case 'generic': {
          this.$store.commit(formLabel, { cards: reply?.attachment?.payload?.elements ?? [] })
          typeIndex = 2
          break
        }
        case 'image': {
          this.$store.commit(formLabel, {
            image: reply?.attachment?.payload?.url ?? '',
          })
          typeIndex = 3
          break
        }
        default: {
          this.$store.commit(formLabel, { message: reply?.text ?? '' })
          break
        }
      }
      if (this.form?.stop_at) {
        this.schedule = true
      }
      this.fetch = false
      this.typTabIndex = typeIndex
      const typeIndexLabel = `${storeLabel}SET_TYPE_INDEX`
      this.$store.commit(typeIndexLabel, typeIndex)
    },
  },
}

export default ReplyMixin
